<template>
  <div class="content-box" :style="bgStyle">
    <div style="text-align: center; margin-top: 100px;">
      <el-row justify="center">
        <img src="/icon/apps/logo.png" style="width: 500px;margin-bottom: 30px"/>
      </el-row>
    </div>
    <div>
      <el-row justify="center">
        <div @click="courseDetail('1')" class="img-box">
          <img src="/icon/apps/精密结构件.png" class="imgStyle"/>
          <h2 class="fontStyle">{{ '精密结构件' }}</h2>
        </div>
        <div @click="courseDetail('2')" class="img-box">
          <img src="/icon/apps/光学.png" class="imgStyle"/>
          <h2 class="fontStyle">{{ '光学' }}</h2>
        </div>
        <div @click="courseDetail('3')" class="img-box">
          <img src="/icon/apps/MIM.png" class="imgStyle"/>
          <h2 class="fontStyle">{{ 'MIM' }}</h2>
        </div>
        <div @click="courseDetail('4')" class="img-box">
          <img src="/icon/apps/紧固件.png" class="imgStyle"/>
          <h2 class="fontStyle">{{ '紧固件' }}</h2>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>

export default {
  name: "LoginMobile",
  data() {
    return {}
  },
  computed: {
    i18n() {
      return this.$store.state.core.i18n
    },
    bgStyle() {
      let obj = {
        // background: 'url(' + this.$store.state.wallpaper.loginWallpaper + ')',
        backgroundSize: 'auto auto'
      };
      if (this.$store.state.wallpaper.isBig) {
        obj.backgroundSize = '100% 100%'
      }
      return obj;
    }
  },
  async created() {

    let data = await this.$http('sysConfigService.getWebConfig')
    this.$store.commit('core/INIT_SYS_CONFIG', data)
    this.$store.commit('wallpaper/INIT_CONFIG', data)
    document.title = this.$store.getters['core/getAppName'];
  },
  methods: {

    courseDetail(item) {
      this.$router.push({path: '/loginMobile1', query: {img: item}})
    },
  }
}
</script>

<style lang="less" scoped>

.content-box {
  position: fixed;
  width: 100%;
  height: 100%;
  background-repeat: repeat;
}

.img-box {
  margin: 20px 10px;
  display: flex;
  flex-direction: column
}

.imgStyle {
  width: 200px;
  height: 120px;
}

.fontStyle {
  font-size: 25px;
  color: white;
  text-align: center;
  background-color: #0a84ff
}

.lang {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 120px;
}


</style>
